import React from "react";
import img01 from "../../assets/img/images/about_img01.svg";
import img02 from "../../assets/img/images/about_img02.png";
import { Link } from "react-router-dom";

const WhoWeAre = (props) => {
  return (
    <section id="about" className="about-area pt-130 pb-130">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-img wow fadeInLeft" data-wow-delay=".2s">
              <img src={img01} alt="" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content wow fadeInRight" data-wow-delay=".2s">
              <div className="section-title mb-30">
                <h2 className="title">
                  What is <span> DIAG </span> Token?
                </h2>
              </div>
              <p className="merriweather-sans">
                The DIAG Token is the core utility asset of the Diagnostica
                ecosystem—built to revolutionize musculoskeletal healthcare
                through AI, wearable tech, and blockchain. Designed for
                real-world use, DIAG powers everything from patient rewards and
                clinician incentives to payments for physiotherapy, diagnostics,
                and medical devices. With a fixed supply of 50 billion tokens
                and growing global adoption, DIAG isn't just a token—it's your
                gateway to the future of intelligent, decentralized, and
                patient-centric healthcare.
              </p>
              <Link
                to="https://diagnostica.app/"
                className="btn"
                target="_blank"
              >
                Read More About Diagnostica
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
